import { CSSProperties, useEffect, useState } from 'react';
/////////////////////////////////////////////////////////
import './CoinsAnimation.css';

interface CoinsAnimationProps {
	animateCoins: boolean;
	coinsRef: React.RefObject<HTMLDivElement>;
}

interface CustomCSSProperties extends CSSProperties {
	'--random-left'?: string;
}

export const CoinsAnimation: React.FC<CoinsAnimationProps> = ({
	animateCoins,
	coinsRef,
}) => {
	/*********************
	// #region Constants
	**********************/
	const NUM_ANIMATED_SHURIKENS = 100;

	/*********************
	// #region States
	**********************/
	const [randomPositions, setRandomPositions] = useState<
		CustomCSSProperties[]
	>([]);

	/*********************
	// #region Observables
	**********************/
	useEffect(() => {
		const generateRandomPositions = () => {
			const positions = Array.from(
				{ length: NUM_ANIMATED_SHURIKENS },
				(_, index) => ({
					'--random-left': `${Math.random() * 100}%`,
					animationDelay: `${index * 0.008}s`,
				})
			);
			setRandomPositions(positions);
		};

		if (coinsRef.current) {
			const rect = coinsRef.current.getBoundingClientRect();
			document.documentElement.style.setProperty(
				'--coins-top',
				`${rect.top + rect.height / 1}px`
			);
			document.documentElement.style.setProperty(
				'--coins-left',
				`${rect.left + rect.width / 3}px`
			);
		}

		generateRandomPositions();
	}, [coinsRef]);

	/*********************
	// #region Template
	**********************/
	return (
		<div className="flex flex-col gap-2">
			<div
				className={`shuriken-container ${
					animateCoins ? 'animate-images' : ''
				}`}
			>
				{[...Array(NUM_ANIMATED_SHURIKENS)].map((_, index) => (
					<img
						key={index}
						src={process.env.VITE_COIN_IMAGE}
						className="drop-shadow-lg"
						style={randomPositions[index]}
					/>
				))}
			</div>
		</div>
	);
};
